<template>
  <span @click="click">
    <slot></slot>
  </span>
</template>

<script>
export default {
  components: {},
  inject: {
    SjQuestion: {
      default: {},
    },
    SjQuestionItem: {
      default: {},
    },
  },
  inheritAttrs: false,
  props: {
    value: Array,
    action: String,
    options: {
      type: Object,
      default: () => {},
    },
  },
  data () {
    return {}
  },
  computed: {
    index () {
      return this.SjQuestionItem.index
    },
    question () {
      return this.SjQuestionItem.question
    },
  },
  watch: {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    click () {
      this[this.action](this.options)
    },
    /**
     * 上移题目
     */
    up () {
      this.SjQuestionItem.up(this.value)
    },
    /**
     * 下移题目
     */
    down () {
      this.SjQuestionItem.down(this.value)
    },
    /**
     * 复制题目
     * @param params
     */
    copy (params = {}) {
      this.SjQuestionItem.copy(this.value, params.toIndex)
    },
    /**
     * 移除题目
     */
    remove () {
      this.$confirm(`此操作将永久删除第${this.index + 1}题, 是否继续?`, '提示', {type: 'warning'}).then(() => {
        this.SjQuestionItem.remove(this.value)
      })
    },
    /**
     * 添加题目
     *
     * @param params
     */
    add (params = {}) {
      this.SjQuestion.add(this.value, params.type, params.toIndex)
    },
  },
  filters: {},
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-editor/packages/sj-question/src/SjQuestionButton.vue